import React, { useEffect } from 'react';
import {
	GanttComponent,
	Inject,
	ColumnsDirective,
	ColumnDirective,
	Selection,
	DayMarkers,
	Toolbar,
	Edit,
	Filter,
	Resize,
	Sort
} from '@syncfusion/ej2-react-gantt';

import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-react-gantt/styles/material.css';

const GanttDeclaration = () => {
	useEffect(() => {
		window.Status = (status) => {
			switch (status) {
				case 'Terminé':
					return 'background-color: #DFFFE2; color: #00A653; border-radius: 24px; padding: 4px 12px;';
				case 'En cours':
					return 'background-color: #DFECFF; color: #006AA6; border-radius: 24px; padding: 4px 12px;';
				case 'Ouvert':
					return 'background-color: red; color: white; border-radius: 15px; padding: 6px;';
				case 'En attente':
					return 'background-color: #E4E4E7; color: #766B7C; border-radius: 24px; padding: 4px 12px;';
				default:
					return '';
			}
		};

		window.StatusContent = (status) => {
			switch (status) {
				case 'Terminé':
					return 'color: #00A653;';
				case 'En cours':
					return 'color: #006AA6;';
				case 'Ouvert':
					return 'color: white;';
				case 'En attente':
					return 'color: #766B7C;';
				default:
					return '';
			}
		};
	}, []);

	const taskFields = {
		id: 'id',
		name: 'title',
		startDate: 'start',
		endDate: 'end',
		progress: 'progress',
		status: 'status'
	};

	const data = [
		{
			id: 1,
			title: 'Déclaration reçue',
			start: new Date('2024-07-01'),
			end: new Date('2024-07-01'),
			progress: 100,
			status: 'Terminé'
		},
		{
			id: 2,
			title: 'Analyse du problème',
			start: new Date('2024-07-01'),
			end: new Date('2024-07-02'),
			progress: 100,
			status: 'Terminé'
		},
		{
			id: 3,
			title: 'Affectation technicien',
			start: new Date('2024-07-02'),
			end: new Date('2024-07-03'),
			progress: 100,
			status: 'Terminé'
		},
		{
			id: 4,
			title: 'Intervention sur site',
			start: new Date('2024-07-03'),
			end: new Date('2024-07-04'),
			progress: 60,
			status: 'En cours'
		},
		{
			id: 5,
			title: 'Clôture',
			start: new Date('2024-07-04'),
			end: new Date('2024-07-04'),
			progress: 0,
			status: 'Ouvert'
		}
	];

	return (
		<div className="w-full">
			<GanttComponent
				id="gantt-sav"
				dataSource={data}
				taskFields={taskFields}
				height="400px"
				treeColumnIndex={1}
				toolbar={['ZoomIn', 'ZoomOut', 'ZoomToFit']}
				timelineSettings={{
					topTier: { unit: 'Day', format: 'dd/MM/yyyy' },
					bottomTier: { unit: 'Hour', format: 'hh tt' },
				}}
				labelSettings={{ leftLabel: 'title' }}
				rowHeight={40}
				taskbarHeight={24}
				allowSorting
				allowFiltering
				highlightWeekends
			>
				<ColumnsDirective>
					<ColumnDirective field="id" headerText="ID" width="60" />
					<ColumnDirective field="title" headerText="Étape" width="250" />
					<ColumnDirective field="start" headerText="Début" width="130" format="dd/MM/yyyy" />
					<ColumnDirective field="end" headerText="Fin" width="130" format="dd/MM/yyyy" />
					<ColumnDirective field="progress" headerText="Avancement" width="120" textAlign="Right" />
					<ColumnDirective
						field="status"
						headerText="Statut"
						width="150"
						template={(props) => {
							return (
								<div
									style={{ ...(window.Status && { ...parseStyle(window.Status(props.status)) }) }}
								>
									<span
										style={{ ...(window.StatusContent && { ...parseStyle(window.StatusContent(props.status)) }) }}
									>
										{props.status}
									</span>
								</div>
							);
						}}
					/>
				</ColumnsDirective>
				<Inject services={[Selection, DayMarkers, Toolbar, Edit, Filter, Resize, Sort]} />
			</GanttComponent>
		</div>
	);
};

// 🔧 Petit utilitaire pour parser les styles string vers objet
function parseStyle(styleStr) {
	return styleStr.split(';').filter(Boolean).reduce((styleObj, rule) => {
		const [key, value] = rule.split(':');
		if (key && value) {
			styleObj[key.trim()] = value.trim();
		}
		return styleObj;
	}, {});
}

export default GanttDeclaration;
